import { render, staticRenderFns } from "./ReCardKBPostEdit.vue?vue&type=template&id=73882c18&scoped=true"
import script from "./ReCardKBPostEdit.vue?vue&type=script&lang=js"
export * from "./ReCardKBPostEdit.vue?vue&type=script&lang=js"
import style0 from "./ReCardKBPostEdit.vue?vue&type=style&index=0&id=73882c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73882c18",
  null
  
)

export default component.exports